// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"e3a89c5c","232":"82dd9baf","320":"c7a4045f","353":"03d606f0","406":"a1cd1fae","762":"41716630","785":"ff96c387","808":"c7a4045f"}[chunkId] + ".chunk.css";
};